import './table.scss';
import React, { useRef, useState } from 'react';
import { Typography, TableBody, TableRow, TableCell, Tooltip } from '@mui/material';
import { getTableTextColor, getTableCellBgColor } from '../../utils/commonUtils';
import TextOverFlowToolTip from './TextOverFlowToolTip';

export default function TableService({ rows, columns }) {
  // Create Ref

  return (
    <TableBody className="table-body-container">
      {rows?.map((rowItem, rowIndex) => (
        <TableRow
          style={{ width: '100%' }}
          key={rowIndex}
          className={`hover:bg-[#f7f8fa] hover:border-transparent`}
        >
          {columns.map((cell, cellIndex) =>
            Boolean(cell?.Cell) ? (
              /* table action button */
              <TableCell className="max-w-[100px]" key={cellIndex}>{cell.Cell(rowItem)}</TableCell>
            ) : cell.accessor === 'Sno' ? (
              /* table serial number */
              <TableCell
                className="!pl-[25px]"
                key={cellIndex}
              >
                <Typography class={`fs-12 ff-Roboto fw-regular`}>
                  {/* table serial number */}
                  {rowItem[cell.accessor]}
                </Typography>
              </TableCell>
            ) : cell.textWithIcon ? (
              <TableCell
                className="max-w-[100px]"
                key={cellIndex}
              >
                <Typography
                  style={{
                    ...cell?.style,
                    color: getTableTextColor(rowItem[cell.accessor]),
                    backgroundColor: cell?.bgColor ? getTableCellBgColor(rowItem[cell.accessor]) : 'transparent',
                  }}
                  class="fs-12 ff-Roboto fw-regular table-td-overflow !capitalize"
                >
                  {/* table text with icon */}
                  {cell.textWithIcon ? cell.icon() : null}
                  {/*  table data */}
                  {rowItem[cell.accessor] || '-'}
                </Typography>
              </TableCell>
            ) : (
              <TextOverFlowToolTip
                capitalize={cell?.capitalize}
                text={rowItem[cell.accessor]}
                key={cellIndex}
              />
            ),
          )}
        </TableRow>
      ))}
    </TableBody>
  );
}
